export function formatMoeda(valor: number | string | null | undefined, decimals = 2, maxDecimals = decimals): string {
  return Number(valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: decimals,
    maximumFractionDigits: maxDecimals,
  });
}

export function formatMoedaSemSimbolo(valor: number | string | null | undefined, decimals = 2): string {
  return Number(valor || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

// Margem percentual de venda sobre custo. Retorna "—" quando custo invalido.
export function formatMargem(venda: number | string | null | undefined, custo: number | string | null | undefined): string {
  const v = Number(venda || 0);
  const c = Number(custo || 0);
  if (!c || c <= 0) return '—';
  const margem = ((v - c) / c) * 100;
  return margem.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%';
}

// Termo de busca que e SO numero vira valor pra casar com uma coluna de dinheiro.
// Devolve `null` (= "isso nao e um valor") assim que aparece qualquer letra ou simbolo,
// pra quem chama seguir tratando o termo como texto.
//
// Regra de leitura pt-BR, na ordem:
//   - tem virgula?          ela e o decimal e o ponto e milhar  → '1.500,00' = 1500
//   - so ponto(s) de 3 em 3? tambem e milhar                    → '1.500'    = 1500
//   - resto                  o ponto e decimal                  → '500.00'   = 500
//
// Diferente do `parseMoeda`, que devolve 0 pra entrada invalida (nao distingue "zero" de
// "nao e numero") e le '1.500' como 1,5 — ali o valor ja vem de um campo de dinheiro,
// aqui vem de uma caixa de busca onde o usuario digita qualquer coisa.
export function parseValorBusca(termo: string | null | undefined): number | null {
  const t = String(termo ?? '').trim();
  if (!/^\d[\d.,]*$/.test(t)) return null;
  let n: string;
  if (t.includes(',')) n = t.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(t)) n = t.replace(/\./g, '');
  else n = t;
  const v = Number(n);
  return Number.isFinite(v) ? v : null;
}

export function parseMoeda(valor: string | number | null | undefined): number {
  if (valor === '' || valor == null) return 0;
  if (typeof valor === 'number') return valor;
  const s = String(valor).trim();
  if (s === '') return 0;
  if (s.includes(',')) {
    const n = Number(s.replace(/[^\d,-]/g, '').replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
  }
  const n = Number(s.replace(/[^\d.-]/g, ''));
  return Number.isFinite(n) ? n : 0;
}
